import { CreateWidgetsMap } from '../types/WidgetModule';

export function defineWidgets<T extends Record<string, () => Promise<any>>>(
  widgets: T
): CreateWidgetsMap<T> {
  return widgets as CreateWidgetsMap<T>;
}
